<template>
  <div>
    <main-toolbar>
      <v-toolbar-title>Alerts</v-toolbar-title>
      <v-spacer />
      <v-btn
        text
        @click="editRecordId = 'new'"
        :disabled="loading || alertsLoading"
      >
        <v-icon small>fa-plus</v-icon>
        <div v-if="!appSmall">&nbsp;Add Alert</div>
      </v-btn>
    </main-toolbar>
    <v-container
      style="position: absolute; top: 0; left: 0; width: 100%; z-index: 10;"
      class="text-center"
      fluid
      align-center
      justify-center
      v-if="loading"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-container>
    <v-simple-table
      v-if="alerts.length"
      class="elevation-1"
      fill-height
    >
      <thead>
        <tr>
          <th style="width: 70px;"></th>
          <th>Name</th>
          <th>Description</th>
          <th>Enabled</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in alerts"
          :key="item.id"
        >
          <td class="layout pt-1">
            <v-btn
              icon
              small
              color="black"
              :disabled="loading || alertsLoading"
              @click="editRecordId = item.id"
            >
              <v-icon small>fa-edit</v-icon>
            </v-btn>
            <v-btn
              class="ml-0"
              icon
              small
              color="black"
              :disabled="loading || alertsLoading"
              @click="deleteItem(item)"
            >
              <v-icon small>fa-trash-alt</v-icon>
            </v-btn>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.description }}</td>
          <td><v-icon v-if="item.enabled">fa-check</v-icon></td>
        </tr>
      </tbody>
    </v-simple-table>
    <AlertEditorDialog
      v-if="editRecordId"
      :recordId="editRecordId"
      @close="editRecordId = null"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AlertEditorDialog from './AlertEditorDialog'
import PaginationMixin from '@/mixins/PaginationMixin'

export default {
  mixins: [PaginationMixin],
  components: {
    AlertEditorDialog
  },
  data () {
    return {
      loading: true,
      editRecordId: null
    }
  },
  computed: {
    ...mapState('alerts', {
      alertsLoading: 'loading',
      alerts: 'data',
      alertsMeta: 'meta'
    })
  },
  methods: {
    ...mapActions('alerts', {
      findAlerts: 'find',
      deleteAlert: 'delete'
    }),
    async deleteItem (item) {
      if (!window.confirm('Are you sure you want to delete this alert?')) {
        return
      }
      this.loading = true
      try {
        await this.deleteAlert(item.id)
        this.loading = false
      } catch (e) {
        this.loading = false
        throw e
      }
    },
    async loadData () {
      this.loading = true
      try {
        await this.findAlerts({
          params: {
            rowCount: 500
          }
        })
        this.loading = false
      } catch (e) {
        this.loading = false
        throw e
      }
    }
  },
  async created () {
    await this.loadData()
  }
}
</script>
